import type { Finding } from "./Finding";
import { hasImpact } from "./hasImpact";
import { isImportant } from "./isImportant";
import { SEVERITY_RANK } from "./SEVERITY_RANK";

const FIX_FIRST_LIMIT = 3;

// «Главное» и «Ещё исправить»: самые важные ошибки, не больше трёх и не больше одной на код —
// три карточки «враг ушёл» подряд ничего не добавляют. Первая — главное в матче.
// Порядок — по важности (`impact`), ошибки ниже порога важности остаются в секциях.
// Старый разбор без важности — по оценке (`bad`, затем `warn`), при равной — порядок бэкенда.
export const selectFixFirst = (findings: readonly Finding[]): Finding[] => {
  const rated = hasImpact(findings);
  const candidates = findings
    .map((finding, index) => ({ finding, index }))
    .filter(({ finding }) => finding.severity !== "good" && isImportant(finding, rated))
    .sort(
      (a, b) =>
        (rated ? b.finding.impact - a.finding.impact : 0) ||
        SEVERITY_RANK[b.finding.severity] - SEVERITY_RANK[a.finding.severity] ||
        a.index - b.index,
    );
  const seen = new Set<Finding["code"]>();
  const top: Finding[] = [];
  for (const { finding } of candidates) {
    if (top.length === FIX_FIRST_LIMIT) {
      break;
    }
    if (!seen.has(finding.code)) {
      seen.add(finding.code);
      top.push(finding);
    }
  }
  return top;
};
